export default "__VITE_ASSET__0f319af4__"